/**
 * Automation Module Styles
 */

// Shared styles can be added here as the module grows
export {};
